import axios from 'axios';
import md5 from 'md5';
import * as graphql from 'graphql-request';
import conf from '../config/index';

axios.interceptors.request.use((config) => {
  if (!config.url.includes('https://data.jianshukeji.com') && localStorage.getItem('token') !== null) {
    config.headers.token = localStorage.getItem('token');
  }
  return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(response => response, (error) => {
  if (error && error.response) {
    error.message = error.response.data.message;
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

/**
 * 生成随机字符串
 */
function rand() {
  return Math.random().toString(36).substr(2);
}

export default {
  /**
   * 生成签名
   * @param params 参数列表
   */
  makeSign(params) {
    const keyList = [];
    Object.keys(params).forEach((key) => {
      keyList.push(key);
    });
    keyList.sort();
    let tempStr = '';
    keyList.forEach((key) => {
      tempStr += params[key];
    });
    return md5(tempStr + conf.apiAppSecret);
  },
  /**
   * 生成接口调用URL
   * @param uri 接口URI
   * @param params 参数列表
   * @returns string
   */
  makeUrl(uri, params) {
    if (params === undefined || params === null) {
      // eslint-disable-next-line
      params = {};
    }
    if (uri.indexOf('?') > -1) {
      uri.substr(uri.indexOf('?') + 1).split('&').forEach((p1) => {
        const p2 = p1.split('=');
        params[p2[0]] = decodeURIComponent(p2[1]);
      });
    }
    params.appid = conf.apiAppId;
    params.nonce = rand();
    params.timestamp = +new Date() / 1000;
    params.version = conf.apiVersion;
    const sign = this.makeSign(params);
    const queryList = [];
    Object.keys(params).forEach((key) => {
      queryList.push(`${key}=${encodeURIComponent(params[key])}`);
    });
    queryList.push(`sign=${sign}`);
    return `${conf.apiServer}${uri}${uri.includes('?') ? '&' : '?'}${queryList.join('&')}`;
  },
  /**
   * 发送Api Get请求
   * @param uri 接口URI
   * @param params
   */
  get(uri, params) {
    const url = this.makeUrl(uri, params);
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        const json = response.data;
        if (json.error !== undefined && json.error === '') {
          resolve(json);
        } else {
          reject(json);
        }
      }).catch((error) => {
        reject(error);
      });
    });
  },
  /**
   * 发送Api Post请求
   * @param uri 接口URI
   * @param json
   */
  post(uri, params) {
    const url = this.makeUrl(uri, null);
    return new Promise((resolve, reject) => {
      axios.post(url, params, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
        const json = response.data;
        if (json.error !== undefined && json.error === '') {
          resolve(json);
        } else if (json.error === 'TOKEN') {
          localStorage.clear();
          window.location.href = `${conf.path}`;
        } else {
          reject(json);
        }
      }).catch((error) => {
        reject(error);
      });
    });
  },
  /**
   * 上传文件
   * @param uri 接口URI
   * @param dir 保存目录
   * @param file
   */
  file(uri, dir, file) {
    const formData = new FormData();
    formData.append('file', file);
    const url = this.makeUrl(uri, { dir });
    return new Promise((resolve, reject) => {
      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          const json = response.data;
          if (json.error !== undefined && json.error === '') {
            resolve(json);
          } else {
            reject(json);
          }
        }).catch((error) => {
          reject(error);
        });
    });
  },
  files(uri, dir, files) {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files[]', file);
    });
    const url = this.makeUrl(uri, { dir });
    return new Promise((resolve, reject) => {
      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          const json = response.data;
          if (json.error !== undefined && json.error === '') {
            resolve(json);
          } else {
            reject(json);
          }
        }).catch((error) => {
          reject(error);
        });
    });
  },
  /**
   * 删除上传文件
   */
  deleteFile(uri) {
    return this.get('/file/delete', { uri });
  },
  /**
   * 格式化错误信息
   * @param json 错误信息
   * @param includeErrors 是否包含详细错误
   * @param sep 多条错误信息的分隔符
   * @return string
   */
  formatError(json, includeErrors = true, sep = '<br />') {
    const msg = [json.message];
    if (includeErrors) {
      if (json.errors !== undefined) {
        Object.keys(json.errors).forEach((attr) => {
          json.errors[attr].forEach((error) => {
            msg.push(error);
          });
        });
      }
    }
    return msg.join(sep);
  },
  /**
   * GraphQL查询
   * @param query
   * @returns {Promise<object>}
   */
  graphQLQuery(query) {
    let token = '';
    const loginInfo = localStorage.getItem('loginInfo');
    if (loginInfo !== null) {
      token = JSON.parse(loginInfo).token;
    }
    const client = new graphql.GraphQLClient(this.makeUrl('/graph-ql', {}), {
      headers: {
        token,
      },
    });
    return client.request(query);
  },
};



// WEBPACK FOOTER //
// ./src/lib/Api.js